class CasesAPI {

  static all(state, sub_id) {
    let url = this.postsUrl(state, sub_id)

    return fetch(url, {
      credentials: 'same-origin'
    })
    .then(this.handleStatus)
  }

  static handleStatus(response) {
    if (!response.ok) {
      // Fetch doesn't reject on HTTP error status
      throw Error(`Request rejected with status ${response.status}`)
    }
    return response
  }

  static postsUrl(params) {
    const {currentBranch, count, offset} = params
    const branches = currentBranch ? `&Expertises=${currentBranch}` : ''
    return `/wp-json/wp/v2/cases?per_page=${count}&offset=${offset}${branches}`
  }

}
export default CasesAPI



// WEBPACK FOOTER //
// ./src/js/app/api/CasesAPI.js